import {
  PrimaryColor,
  ThemeMode,
  defaultPrimaryColorKey,
} from '../../shared/constants';
import {
  LocalStorageKey,
  LocalStorageService,
} from '../../shared/storage/local-storage';
import { darkPalette } from '../../styles/palette-dark';
import { lightPalette } from '../../styles/palette-light';
import { mergePrimaryIntoPalette } from '../../styles/palette-with-primary';
import { createAppTheme } from '../../styles/theme';

const VALID_THEMES: string[] = [ThemeMode.light, ThemeMode.dark];
const VALID_PRIMARY_COLORS: string[] = Object.values(PrimaryColor);

/**
 * Builds the same MUI theme as the app, using only localStorage (no React context).
 * Used where the tree is outside {@link ThemeProvider} (e.g. ErrorBoundary fallback).
 */
export function createAppThemeFromLocalStorage() {
  const storedTheme = LocalStorageService.getValue(LocalStorageKey.theme);
  const mode =
    storedTheme && VALID_THEMES.includes(storedTheme as string)
      ? (storedTheme as ThemeMode)
      : ThemeMode.light;

  const storedPrimary = LocalStorageService.getValue(
    LocalStorageKey.primaryColor,
  );
  const primaryColor =
    storedPrimary && VALID_PRIMARY_COLORS.includes(storedPrimary as string)
      ? (storedPrimary as PrimaryColor)
      : defaultPrimaryColorKey;

  const basePalette = mode === ThemeMode.dark ? darkPalette : lightPalette;
  const palette = mergePrimaryIntoPalette(
    basePalette as Record<string, unknown>,
    primaryColor,
    mode === ThemeMode.dark,
  );

  return createAppTheme({
    ...palette,
    mode: mode === ThemeMode.dark ? 'dark' : 'light',
  });
}
